import { render, staticRenderFns } from "./promocionesVer.vue?vue&type=template&id=52d9ee1a&scoped=true&"
import script from "./promocionesVer.vue?vue&type=script&lang=js&"
export * from "./promocionesVer.vue?vue&type=script&lang=js&"
import style0 from "./promocionesVer.vue?vue&type=style&index=0&id=52d9ee1a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d9ee1a",
  null
  
)

export default component.exports